export enum EmailChangeStep {
  REQUEST = "request",
  CONFIRM = "confirm",
}

export const MILLISECONDS_PER_SECOND = 1000;

export const VERIFICATION_CODE_LENGTH = 6;

export const VERIFICATION_CODE_PATTERN = "^[0-9]{6}$";

/**
 * The request endpoint allows 2 calls per minute. A 30s gate between requests keeps the resend
 * button alone from ever reaching that ceiling.
 */
export const RESEND_COOLDOWN_SECONDS = 30;

export const PENDING_EMAIL_CHANGE_STORAGE_KEY = "pendingEmailChange";
